export function sendGTMEventOnce({
  event,
  value,
}: {
  event: string;
  value: string;
}): void {
  (window as any).dataLayer = (window as any).dataLayer || [];
  const alreadySent = (window as any).dataLayer.find(
    (v: any) => v.event === event
  );
  if (!alreadySent) {
    (window as any).dataLayer.push({ event, value });
  }
}

export const getBgColor = (
  planName: string,
): {
  bg: string;
  border: string;
} => {
  const normalized = planName?.trim().toLowerCase();

  switch (normalized) {
    case "most popular":
      return { bg: "#FFE9EE", border: "#FF5A6A" }; // bg is #FFE9EE
    case "best value":
      return { bg: "#CEF5F1", border: "#0BCEBB" }; // bg is #CEF5F1
    case "secure savings":
      return { bg: "#D7F2FE", border: "#35C0FC" }; // bg is #D7F2FE
    case "100% green":
      return { bg: "#E0F7E9", border: "#0BCEBB" }; // bg is #0BCEBB
    default:
      return { bg: "#FFE9EE", border: "#FF5A6A" }; // default fallback
  }
};
